import React from "react";

const ProactiveMessage = () => {
  return (
    <div className="bg-gray-50 py-12 md:py-24">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="order-2 md:order-1">
            <img
              src="/images/mature_professional_man_relaxing_.jpg"
              alt="Professional relaxing at desk"
              className="rounded-lg shadow-lg w-full h-[400px] object-cover"
            />
          </div>

          {/* Text Side */}
          <div className="order-1 md:order-2">
            <h2 className="text-2xl md:text-4xl font-light leading-relaxed text-gray-800">
              Stay proactive and prepared to elevate your business while
              ensuring full compliance with IRS tax regulations. Let's work
              ahead to set you up for smooth, stress-free success.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProactiveMessage;
